import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { LoggingService } from '../../../shared/services/logging';
import { ReplaySubject } from 'rxjs';
import { IColumn, getDynamicColumns } from '../../../shared';

@Component({
    selector: 'ef-expense-pdbo',
    templateUrl: './expense-pdbo.component.html',
    styleUrls: ['./expense-pdbo.component.scss'],
    standalone: false
})
export class ExpensePdboComponent implements OnInit, OnChanges {
    @Input() public items: any;
    @Output() public Cancel = new EventEmitter();
    @Output() public Save = new EventEmitter();
    public pdboFormGroup: UntypedFormGroup;
    cols: IColumn[] = [];
    filterItems = [
        'pdbo_type',
        'pdbo_amount',
        'dailyperdiemamount',
        'expenseID'
    ];
    constructor(private log: LoggingService) {
        this.pdboFormGroup = new UntypedFormGroup({});
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.items &&
            changes.items.currentValue &&
            Array.isArray(changes.items.currentValue) &&
            changes.items.currentValue.length > 0
        ) {
            // const dc = getDynamicColumns(
            //     changes.items.currentValue[0],
            //     this.filterItems
            // );
            const dc = Object.keys(changes.items.currentValue[0]).filter(
                x => !this.filterItems.includes(x)
            );
            this.cols = dc.map(c => ({
                field: c,
                header: c,
                showColumn: true,
                group: ''
            }));
            this.log.verbose({
                type: 'ExpensePdboComponent:ngOnChanges',
                changes,
                cols: this.cols
            });
        }
    }
    public GetHeaderName(col: IColumn): string {
        switch (col.field.toLocaleLowerCase()) {
            case 'pdbo_typedesc':
                return 'Per Diem Breakout';
            case 'inuse':
                return 'Include';
            case 'pdbo_date':
                return 'Travel Date';
            default:
                return col.field;
        }
    }

    ngOnInit(): void {}
    public onCancel() {
        this.log.verbose({ type: 'ExpensePdboComponent:onCancel' });
        this.Cancel.emit();
    }
    public onSave($event: any) {
        this.log.verbose({ type: 'ExpensePdboComponent:onSave', $event });
        this.Save.emit($event);
    }
}
